import { useEffect, useState, useCallback, useMemo } from "react";
import { serverFetch } from "../../server";
import { Button, message, Table, Card, Typography, Space, Checkbox } from "antd";
import { DownOutlined, RightOutlined } from "@ant-design/icons";
import StockDocCnt from "./stock-doc-cnt";
import { dictsGetProductsForSale } from "../../extensions/dicts";
import { isMobile, ScanButton, menuSize } from "../../extensions/design";
import { Scan } from "../../controls";
import { fmtDate } from "@/extensions/utils";
import ScanMobile from "@/controls/scan/scan-mobile";
const { Text } = Typography;

const StockDocCnts = ({ id, onClose, vid, onCntSaved, exposeScan, exposeCloseScan }) => {
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState(null);
  const [doc, setDoc] = useState(null);
  const [scanModalOpen, setScanModalOpen] = useState(false);

  const [products, setProducts] = useState([]);

  const getData = () => {
    serverFetch(`store/DocCntList/${id}`)
      .then(data => {
        setLoading(false);
        setItems(data);
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }


  const getDoc = () => {
    serverFetch(`store/${id}`)
      .then(data => setDoc(data))
      .catch(e => message.error(e.userMessage));
  }

  useEffect(() => {
    getData();
    dictsGetProductsForSale(setProducts, 0);
    getDoc();
  }, [id]);

  const columns = [
    { dataIndex: "id", title: "#", },
    { dataIndex: "productName", title: "Наименование", },
    { dataIndex: "productUnit", title: "Ед.", },
    { dataIndex: "coeff", title: "Коэфф.", },
    { dataIndex: "qty", title: "Кол.", },
    { dataIndex: "qtyFact", title: "Факт.", },
    { dataIndex: "price", title: "Цена", },
    { dataIndex: "syma", title: "Сумма", align: "right" },
  ]

  const symaTotal = useMemo(
    () => items.reduce((acc, row) => acc + (Number.parseFloat(row.syma) || 0), 0),
    [items]
  )

  const onItemClose = (refresh) => {
    setSelected(null);
    if (refresh) {
      getData();
      getDoc();
      onCntSaved?.();
    } else {
      setItems([...items.filter(i => i.id)]);
    }
  }

  const onRowClick = record => setSelected(selected === record.id ? null : record.id);

  const onAdd = () => {
    setItems([...items.filter(i => i.id), { id: 0, qty: 1, coeff: 1, storeDocId: id }]);
    setSelected(0);
  }

  const onScan = useCallback((value) => {    
    setLoading(true);
    let barcode = value;
    if (barcode.length > 15 && barcode.startsWith("01"))
      barcode = barcode.slice(3, 16);
    serverFetch(`product/GetByBarcode?barcode=${barcode}`)
      .then(data => {        
        if (data) {
          setItems(prevItems => [...prevItems.filter(i => i.id), 
            { id: 0, qty: 1, 
              coeff: doc?.vid === 1 ? data.putCoeff : 1, 
              storeDocId: id, 
              productId: data.id, 
              price: doc?.vid === 1 ? data.putPrice : data.expPrice, 
              syma: doc?.vid === 1 ? data.putPrice : data.expPrice,
              productUnit: doc?.vid === 1 ? data.putUnit : data.expUnit
             }
          ]);
          setSelected(0);
          setLoading(false);
        }
        else {
          setLoading(false);
          message.error('Товар не найден!');
        }
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }, [doc, id]);

  const canAdd = doc && !doc.active;

  const handleScan = useCallback((value) => {
    setScanModalOpen(false);
    onScan(value);
  }, [onScan]);

  const openScanModal = useCallback(() => {setScanModalOpen(true);}, []);

  const closeScanModal = useCallback(() => {setScanModalOpen(false);}, []);

  useEffect (() => {
    if (exposeScan) { exposeScan(() => openScanModal); }
    if (exposeCloseScan) { exposeCloseScan(closeScanModal); }
  }, [exposeScan, exposeCloseScan, openScanModal, closeScanModal]);

  useEffect(() => {
    return () => {
      if (exposeCloseScan) {
        exposeCloseScan(() => {});
      }
    };
  }, [exposeCloseScan]);

  return !isMobile ? (<div>
    {canAdd && <Button onClick={onAdd} disabled={!canAdd || loading}>Добавить</Button>}
    <ScanButton title="Просканируйте штрихкод или QR код товара" onScan={onScan}/>
    {canAdd && <Scan onScan={onScan}/>}
    <Table dataSource={items} loading={loading} columns={columns} size="small" className="table-item" pagination={false} rowKey="id"
      expandable={{
        expandedRowRender: (record) => <StockDocCnt onClose={onItemClose} itemDefault={record} products={products} vid={vid}/>, expandedRowKeys: [selected],
        onExpand: (expanded, record) => setSelected(expanded ? record.id : null),
        expandIcon: ({ expanded, onExpand, record }) => expanded ? 
        <DownOutlined onClick={(e) => {onExpand(record, e); e.stopPropagation();}} /> : 
        <RightOutlined onClick={(e) => {onExpand(record, e); e.stopPropagation();}} />,
        rowExpandable: () => true,
        className: "cl-abons-expandable",
      }}
      onRow={record => ({ onClick: () => onRowClick(record) })}
      rowSelection={{ type: 'radio', selectedRowKeys: [selected], renderCell: checked => <div className={checked ? "list-indicator" : ""} /> }}
      summary={() => (
        <Table.Summary fixed>
          <Table.Summary.Row>
            <Table.Summary.Cell index={0} colSpan={9} align="right">
              <Text strong>Итого</Text>
            </Table.Summary.Cell>
            <Table.Summary.Cell index={9} align="right">
              <Text strong>{symaTotal}</Text>
            </Table.Summary.Cell>
          </Table.Summary.Row>
        </Table.Summary>
      )}
      />
  </div>) : (
  <div>
    {canAdd && <Button style={{width: "100%"}} onClick={onAdd} disabled={!canAdd || loading}>Добавить</Button>}
    {canAdd && scanModalOpen && <ScanMobile onScan={handleScan} onClose={() => setScanModalOpen(false)}/>}
    <div className="stock-scrollable-list" style={{ height: window.innerHeight - menuSize - 65 }}>
      {loading ? (
        <div style={{ textAlign: "center", marginTop: "20px", fontSize: "14px" }}>Загрузка...</div>
      ) : items.length === 0 ? (
        <div style={{ textAlign: "center", marginTop: "20px", fontSize: "14px" }}>Нет данных</div>
      ) : (
        items.map(item => {
          const isExpanded = selected === item.id;
          return (
            <Card key={item.id} className="stock-card" onClick={() => setSelected(isExpanded ? null : item.id)}
              style={{ borderLeft: `4px solid ${isExpanded ? "#2f6f00" : "#d9d9d9"}`, cursor: "pointer"}} >
              <div className="stock-osv-item-line-long-and-short" style={{gridTemplateColumns: "1fr 80px"}}>
                <Text strong>{item.productName || "Новый товар"}</Text>
                <Text strong style={{textAlign: "right"}}>#{item.id}</Text>
              </div>
              <div className="stock-osv-item-line-double">
                <div><Text>Кол-во: {item.qty || 0} {item.productUnit || ""}</Text></div>
                <div style={{ textAlign: "right" }}><Text>Факт.кол-во: {item.qtyFact || 0} {item.productUnit || ""} </Text></div>
              </div>
              <div className="stock-osv-item-line-double">
                <div><Text>Коэфф.: {item.coeff || 1}</Text></div>
                <div style={{ textAlign: "right" }}><Text>Цена: {item.price || 0}</Text></div>
              </div>
              <div className="stock-osv-item-line-double">
                <Text strong>Сумма: {item.syma || 0}</Text>
              </div>
              <div style={{ maxHeight: isExpanded ? 800 : 0, opacity: isExpanded ? 1 : 0, overflow: "hidden"}}
                onClick={(e) => e.stopPropagation()}>
                {isExpanded && (<StockDocCnt onClose={onItemClose} itemDefault={item} products={products} vid={vid}/>)}
              </div>
            </Card>
          );
        })
      )}
      {!loading && items.length > 0 && (
        <div style={{ padding: "8px 12px", textAlign: "right", borderTop: "1px solid #f0f0f0" }}>
          <Text strong>Итого по сумме: {symaTotal}</Text>
        </div>
      )}
    </div>
  </div>)
}

export default StockDocCnts;